import { createFileRoute } from "@tanstack/react-router";
import { PageSkeleton } from "@/components/PageSkeleton";
import Terms from "@/pages/Terms";
import { EMBED_BASE_URL } from "@/config/constants";

const TITLE = "Terms of Service, EmbedKit";
const DESCRIPTION =
  "EmbedKit terms of service. Free embeddable widgets provided as-is with no warranty.";
const URL = `${EMBED_BASE_URL}/terms`;

export const Route = createFileRoute("/_dashboard/terms")({
  component: Terms,
  pendingComponent: PageSkeleton,
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:url", content: URL },
      { name: "twitter:title", content: TITLE },
      { name: "twitter:description", content: DESCRIPTION },
    ],
    links: [{ rel: "canonical", href: URL }],
  }),
});
